module.exports = __webpack_public_path__ + "static/media/greyDownArrow.2c467000.svg";